<template>
    <div id="login" class="login">
        <header>
            <div class="logo">
                <img src="/img/login_logo.png" alt="logo">
            </div>
        </header>
        <div class="content">
            <div class="left">
                <div class="info">
                    <template>
                        <div class="info_h1" @click="info.edit=true" v-html="info.title"></div>
                        <div class="info_p" @click="info.edit=true" v-html="info.content.replace(/\r?\n/g, '<br />')"></div>
                    </template>
                    <!-- <template v-if="!info.edit">
                        <div class="info_h1" @click="info.edit=true" v-html="info.title"></div>
                        <div class="info_p" @click="info.edit=true" v-html="info.content.replace(/\r?\n/g, '<br />')"></div>
                    </template>
                    <template v-else>
                        <div style="width: 100%;background-color: #fff;padding:10px;border-radius:5px;">
                            <mc-layout-row :label-show="false">
                                <el-input type="text" v-model="info.title"></el-input>
                            </mc-layout-row>
                            <mc-layout-row :label-show="false">
                                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="info.content"></el-input>
                            </mc-layout-row>
                            <mc-layout-row :label-show="false">
                                <el-button @click="info.edit=false">完成</el-button>
                            </mc-layout-row>
                        </div>
                    </template> -->
                </div>
            </div>
            <div class="right">
                <div class="login-board">
                    <div class="login-board-title">
                        <p v-if=" this.$store.state.view.type==`user`">用户登录</p>
                        <p v-else>管理员登录</p>
                    </div>
                    <mc-layout-row label-icon-left="iconfont okp-fonts-user" :labelWidth="70">
                        <el-input type="text" placeholder="账号" v-model="username" clearable @keyup.enter.native="$_login()"></el-input>
                    </mc-layout-row>
                    <mc-layout-row label-icon-left="iconfont okp-3701mima" :labelWidth="70">
                        <el-input type="password" placeholder="密码" v-model="password" clearable @keyup.enter.native="$_login()"></el-input>
                    </mc-layout-row>
                    <el-button type="primary" class="login-board-submit" @click="$_login">登录</el-button>
                    <p class="login-board-user-type">
                        <label v-if="this.$store.state.view.type ==`user`" @click="$_changeLoginType('admin')">管理员登录</label>
                        <label v-else @click="$_changeLoginType('user')">用户登录</label>
                    </p>
                </div>
            </div>
        </div>
        <footer v-if="!!footer">
          {{ footer.copyright }} {{ footer.project }} | 
          <a target="_blank" :href="footer.icp.link" style="margin-left:5px;">{{footer.icp.text}}</a>
        </footer>
    </div>
</template>

<script>
    const log = new Log("Page/login");
    export default {
        name: "login",
        data() {
            return {
                username: "",
                password: "",
                footer: "",
                info: {
                    edit: false,
                    title: "运维云",
                    content: `采用多租户方式，安全独立
                             与运维一体机对接，提供告警订阅、告警推送和工单服务
                             提升运维效率，实现数据中心主动运维服务`,
                },
            }
        },
        methods: {
            $_getFooter() {
                axios.get("/config/footer.json").then(res => {
                    this.footer = res.data;
                });
            },
            $_changeLoginType(type) {
                this.$store.state.view.type = type
            },
            $_login() {
                switch (this.$store.state.view.type) {
                    case "user":
                        this.$_login_user();
                        break;
                    case "admin":
                        this.$_login_partner();
                        break;
                }
            },
            $_login_user: async function () {
                // let params = {
                //     email: "huxihang@mchz.com.cn",
                //     password: "p09zem@."
                // }
                let params = {
                    email: this.username,
                    password: this.password
                }
                let data = await this.$api.user.login.call(this, params);
                if (data !== false) {
                    axios.defaults.headers.common = {
                        Authorization: "Onekeeper " + data.access_token,
                    };
                    window.sessionStorage.token = data.access_token;
                    window.sessionStorage.refreshToken = data.refresh_token;
                    window.sessionStorage.username = data.username;
                    window.sessionStorage.email = data.email;
                    window.sessionStorage.mobile = data.mobile;
                    window.sessionStorage.userType = "user";
                    this.$router.push({
                        name: "user"
                    });
                }
            },
            $_login_partner: async function () {
                // let params = {
                //     login_username: "zhoul@mchz.com.cn",
                //     login_password: "123456"
                // }
                let params = {
                    login_username: this.username,
                    login_password: this.password
                }
                let data = await this.$api.admin.login.call(this, params);
                if (data !== false) {
                    axios.defaults.headers.common = {
                        Authorization: "Onekeeper " + data.access_token,
                    };
                    window.sessionStorage.token = data.access_token;
                    window.sessionStorage.refreshToken = data.refresh_token;
                    window.sessionStorage.username = data.name;
                    window.sessionStorage.id = data.id;
                    window.sessionStorage.userType = "partner";
                    this.$router.push({
                        name: "admin"
                    });
                }
            },
        },
        created() {
            this.$_getFooter();
            window.sessionStorage.clear();
             this.$store.state.view.type = 'user';
        },
    }
</script>

<style lang="less" scoped>
    @Height_Header: 80px;
    @Height_Footer: 60px;

    .login {
        width: 100%;
        height: ~ "calc(100vh)";
        overflow: hidden;
        background-image: url("/img/login-bg.png");
        background-size: cover;

        header {
            width: 100%;
            height: @Height_Header;
            // padding: 0 40px;
            padding: 0 15px;
            // background-color: #fff;

            .logo {
                width: 100%;
                height: 100%;
                padding: 0 15px;
                display: flex;
                align-items: flex-end;


                img {
                    width: 134px;
                    margin-left: 20px;
                }
            }
        }

        .content {
            width: 100%;
            height:~"calc(100vh - @{Height_Header} - @{Height_Footer})";
            display: flex;

            .left {
                width: 60%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                .info {
                    width: 520px;
                    // cursor: pointer;
                    margin-bottom: 200px;
                    .info_h1 {
                        color: #fff;
                        font-size: 48px;
                        font-weight: 600;
                        margin: 0;
                        line-height: 48 * 2px;
                    }
                    .info_p {
                        color: #fff;
                        font-weight: 300;
                        font-size: 20px;
                        line-height: 40px;
                        margin: 0;
                    }
                }
            }

            .right {
                width: 40%;
                height: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .login-board {
                    width: 390px;
                    padding: 40px;
                    min-height: 300px;
                    background-color: #fff;
                    border-radius: 5px;

                    .login-board-title {
                        width: 100%;
                        height: 60px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        p {
                            font-size: 14px;
                            margin: 0;
                            padding: 0;
                            font-weight: 600;
                        }
                    }

                    .login-board-submit {
                        width: 100%;
                        margin-top: 45px;
                        margin-bottom: 10px;
                    }

                    .login-board-user-type {
                        width: 100%;
                        margin: 10px 0;

                        label {
                            cursor: pointer;
                            color: #409EFF;

                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        }

        footer {
            width: 100%;
            height: @Height_Footer;
            display: flex;
            justify-content: center;
            align-items: center;
            // background-color: #fff;
            color: #fff;

            a {
                text-decoration: none;
                color: #fff;
            }
        }
    }
</style>
